var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25170_24396)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_25170_24396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3437 25.8574C51.3437 11.7795 39.9313 0.367188 25.8535 0.367188C11.7756 0.367188 0.363281 11.7795 0.363281 25.8574C0.363281 39.9352 11.7756 51.3476 25.8535 51.3476C39.9313 51.3476 51.3437 39.9352 51.3437 25.8574Z",
    fill: "url(#paint0_linear_25170_24396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5261 25.8558C51.5261 11.6775 40.0323 0.183594 25.8539 0.183594C11.6755 0.183594 0.181641 11.6775 0.181641 25.8558C0.181641 40.0342 11.6755 51.5281 25.8539 51.5281C40.0323 51.5281 51.5261 40.0342 51.5261 25.8558Z",
    stroke: "url(#paint1_linear_25170_24396)",
    strokeWidth: 0.357143
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25170_24396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3447 25.8535C51.3447 11.7756 39.9323 0.363281 25.8545 0.363281C11.7766 0.363281 0.364258 11.7756 0.364258 25.8535C0.364258 39.9313 11.7766 51.3437 25.8545 51.3437C39.9323 51.3437 51.3447 39.9313 51.3447 25.8535Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25170_24396)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_25170_24396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7585 17.1758C33.24 17.1758 20.4377 51.8859 -3.96777 29.1074L-0.17136 58.9364L76.2992 61.1058V24.7686C60.5712 37.2426 54.2771 17.1759 43.7585 17.1758Z",
    fill: "url(#paint2_linear_25170_24396)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_25170_24396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96933 17.1758C18.4879 17.1758 31.2902 51.8859 55.6957 29.1074L51.8993 58.9364L-24.5713 61.1058V24.7686C-8.84334 37.2426 -2.54917 17.1759 7.96933 17.1758Z",
    fill: "url(#paint3_linear_25170_24396)",
    fillOpacity: 0.7
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_25170_24396",
    x: 0.00306702,
    y: 0.00585938,
    width: 51.7016,
    height: 53.1297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.57143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.439216 0 0 0 0 0.929412 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_25170_24396"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.42857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_25170_24396",
    result: "effect2_innerShadow_25170_24396"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_25170_24396",
    x: -9.68205,
    y: 12.1758,
    width: 91.6955,
    height: 55.3582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25170_24396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25170_24396",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_25170_24396",
    x: -30.2856,
    y: 6.9615,
    width: 96.1956,
    height: 60.5725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25170_24396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25170_24396",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25.7143,
    dy: -12.1429
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_25170_24396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25170_24396",
    x1: 11.2877,
    y1: 43.7005,
    x2: 48.3908,
    y2: 18.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678371,
    stopColor: "#4862F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8A7DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25170_24396",
    x1: 51.2682,
    y1: 0.365667,
    x2: 0.439693,
    y2: 51.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3AEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25170_24396",
    x1: 36.1657,
    y1: 17.1758,
    x2: 36.1657,
    y2: 61.1058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25170_24396",
    x1: 15.5622,
    y1: 17.1758,
    x2: 15.5622,
    y2: 61.1058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C7DE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25170_24396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotIcon);
export default __webpack_public_path__ + "static/media/chatbot_icon.1f8b0eca95c428d3bd47441cc95f042c.svg";
export { ForwardRef as ReactComponent };